import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IVerfuegbarkeitsstatus } from '../_interfaces/verfuegbarkeitsstatus';
import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

@Injectable()
export class VerfuegbarkeitsstatusService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    { name: 'id', type: 'int' },
    { name: 'createdBy', type: 'string' },
    { name: 'created', type: 'DateTimeOffset' },
    { name: 'modifiedBy', type: 'string' },
    { name: 'modified', type: 'DateTimeOffset' },
    { name: 'rowVersion', type: 'byte[]' },
    { name: 'nrVersorgungsunternehmen', type: 'string' },
    { name: 'status', type: 'string' },
    { name: 'bezeichnung', type: 'string' }
  ];

  private verfuegbarkeitsstatusCache = new Map<string, IVerfuegbarkeitsstatus[]>();

  getVerfuegbarkeitsstatusForVersorgungsunternehmen(vu: string): Observable<{ verfuegbarkeitsstatus: IVerfuegbarkeitsstatus[] }> {
    // Prüfe ob es schon im Cache ist
    let cache: Map<string, IVerfuegbarkeitsstatus[]> = null;
    //console.log("VerfuegbarkeitsstatusService.getVerfuegbarkeitsstatusForVersorgungsunternehmen() checking cache:", cache);

    cache = this.verfuegbarkeitsstatusCache;
    if (cache.has(vu)) {
      console.log("VerfuegbarkeitsstatusService.getVerfuegbarkeitsstatusForVersorgungsunternehmen() return from cache:", cache);
      return of({
        verfuegbarkeitsstatus: cache.get(vu)!
      });
    }

    return this.httpClient.get(this.apiBaseUrl + 'verfuegbarkeitsstatus?vu=' + vu, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          // Speichere im Cache
          cache.set(vu, <IVerfuegbarkeitsstatus[]>response.body);
          //console.log("VerfuegbarkeitsstatusService.getVerfuegbarkeitsstatusForVersorgungsunternehmen() updated cache:", cache);

          return { verfuegbarkeitsstatus: <IVerfuegbarkeitsstatus[]>response.body };
        }), catchError(this.handleError))
  }

  initializeVerfuegbarkeitsstatus(): IVerfuegbarkeitsstatus {
    return {
      id: 0,
      createdBy: '',
      created: '',
      modifiedBy: '',
      modified: '',
      rowVersion: '',
      nrVersorgungsunternehmen: '',
      status: '',
      bezeichnung: ''
    };
  }


}
